import { CoffeeIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Mug = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return <CoffeeIcon size={Sizes[size]} {...rest} />;
};

Mug.displayName = 'Mug';
